import React from 'react';

import { connect } from 'react-redux';
import { fromReservation } from 'store/selectors';

import { GuestListHeading } from 'components';

import {
  getNumberOfAdults,
  getNumberOfChildren,
  getNumberOfInfants,
  getNumberOfStudents,
  getNumberOfSeniors,
} from 'helpers/reservation';

import {
  ADULT,
  CHILD,
  INFANT,
  STUDENT,
  SENIOR,
} from 'domain/age';

const getExpectedOfType = (expectedCategories, type) => expectedCategories.find(item => item.code === type) || {};
const getExpectedNumberOfType = (expectedCategories, type) => getExpectedOfType(expectedCategories, type).reserved || 0;

const GuestListHeadingContainer = props => <GuestListHeading {...props} />;
const mapStateToProps = (state, { departure: { id } }) => {
  const guests = fromReservation.getGuestsByDeparture(state, id).map(id => fromReservation.getGuest(state, id));
  const expected = fromReservation.getAgesForDeparture(state, id);

  return {
    adults: getNumberOfAdults(guests),
    expectedAdults: getExpectedNumberOfType(expected, ADULT),
    childs: getNumberOfChildren(guests),
    expectedChilds: getExpectedNumberOfType(expected, CHILD),
    infants: getNumberOfInfants(guests),
    expectedInfants: getExpectedNumberOfType(expected, INFANT),
    students: getNumberOfStudents(guests),
    expectedStudents: getExpectedNumberOfType(expected, STUDENT),
    seniors: getNumberOfSeniors(guests),
    expectedSeniors: getExpectedNumberOfType(expected, SENIOR),
  };
};

export default connect(mapStateToProps)(GuestListHeadingContainer);



// WEBPACK FOOTER //
// ./src/containers/GuestListHeading.js